import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import "./ReturnReplace.scss";
import HeaderOne from "../../../HeaderOne";
import Breadcrumb from "../../../Breadcrumb";
import FooterOne from "../../../FooterOne";
import Swal from "sweetalert2";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const ReturnReplace = () => {
  const { orderId } = useParams();

  const [reason, setReason] = useState("");
  const [returnType, setReturnType] = useState("refund");
  const [comment, setComment] = useState("");
  const [image, setImage] = useState(null);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  // Swal Toast 
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    timer: 2000,
    showConfirmButton: false,
  });

  const errorStyle = {
    border: "1px solid #e53935",
    backgroundColor: "#ffeaea"
  };

  const handleImageUpload = (e) => {
    setImage(e.target.files[0]);
  };

  // ---------------- VALIDATION ----------------
  const validate = () => {
    let temp = {};

    if (!reason.trim()) temp.reason = "Please select a reason";
    if (returnType === "") temp.returnType = "Select refund or replacement";
    if (comment.trim().length < 5) temp.comment = "Comment must be at least 5 characters";

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  const handleSubmit = async () => {
  if (!validate()) {
    Toast.fire({
      icon: "error",
      title: "Please fix the highlighted fields.",
    });
    return;
  }

  try {
    const token = localStorage.getItem("authToken");

    const res = await axios.put(
      `${API_URL}/order/return-request/${orderId}`,
      {
        type: returnType,
        reason,
        comment,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (res.data.success) {
      Swal.fire({
        icon: "success",
        title: "Request Submitted!",
        text:
          returnType === "refund"
            ? "Refund request submitted successfully."
            : "Replacement request submitted successfully.",
        confirmButtonColor: "#3085d6",
      }).then(() => {
        navigate("/user/orders");
      });
    }
  } catch (error) {
    console.error(error);

    Swal.fire({
      icon: "error",
      title: "Request Failed",
      text:
        error?.response?.data?.message ||
        "Something went wrong",
    });
  }
};

  return (
    <>
    <HeaderOne/>
    <Breadcrumb/>
    <div className="return-container mt-10">

      <h2 className="return-header">Return / Replace Request</h2>
      <p className="return-order-id">Order #{orderId}</p>

      <div className="return-section">
        <h3>Reason for Return</h3>
        <select
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="return-select"
        >
          <option value="">Select a reason</option>
          <option value="damaged">Item damaged</option>
          <option value="wrong">Wrong item delivered</option>
          <option value="quality">Poor quality</option>
          <option value="not-needed">No longer needed</option>
          <option value="other">Other</option>
        </select>
      </div>

      <div className="return-section">
        <h3>Return Type</h3>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              checked={returnType === "refund"}
              onChange={() => setReturnType("refund")}
            />
            Refund
          </label>

          <label>
            <input
              type="radio"
              checked={returnType === "replace"}
              onChange={() => setReturnType("replace")}
            />
            Replacement
          </label>
        </div>
      </div>

      {/* <div className="return-section">
        <h3>Upload Image (optional)</h3>
        <input type="file" onChange={handleImageUpload} className="file-input" />

        {image && <p className="file-name">Selected: {image.name}</p>}
      </div> */}

      <div className="return-section">
        <h3>Additional Comments</h3>
        <textarea
          className="return-textarea"
          style={errors.comment ? errorStyle : {}}
          placeholder="Describe your issue..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
      </div>

      <button className="submit-return-btn" onClick={handleSubmit}>
        Submit Return Request
      </button>
    </div>
    <FooterOne/>
    </>
  );
};

export default ReturnReplace;